// File: index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { storageService } from './utils/storageService';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { LanguageProvider } from './context/LanguageContext';
import { ExhibitionProvider } from './context/ExhibitionContext';
import { UserIdProvider } from './context/UserContext';
import './styles/styles.css'; 

// Clear API cache on new app deployment
const BUILD_VERSION = process.env.REACT_APP_BUILD_TIME || '1';
const storedVersion = localStorage.getItem('app_build_version');
if (storedVersion !== BUILD_VERSION) {
  storageService.clearAllCaches();
  localStorage.setItem('app_build_version', BUILD_VERSION);
}

// Register service worker before rendering
const APP_LOADED_AT = Date.now();

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const waiting = registration.waiting;
    if (!waiting) return;

    // Update found while the app is launching: apply it silently and reload
    // — the user hasn't started doing anything yet, so this is invisible and
    // they get the new version on THIS launch instead of the next one.
    if (Date.now() - APP_LOADED_AT < 15000) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload();
      }, { once: true });
      waiting.postMessage({ type: 'SKIP_WAITING' });
      return;
    }

    // Update found mid-session: don't yank the page out from under the user;
    // surface the "Refresh" snackbar instead (AppToasts.jsx).
    window.dispatchEvent(
      new CustomEvent('sw-update-available', { detail: registration })
    );
  },
});

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <UserIdProvider>
        <ExhibitionProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ExhibitionProvider>
      </UserIdProvider>
    </LanguageProvider>
  </React.StrictMode>
);